import { SubmissionError } from 'redux-form';
import { isUndefinedNullOrEmpty } from '../../js/utils';

export const reliablyHandleFormSubmit = (handler) => {
    return new Promise(resolve => resolve()).then(() => {
        try {
            return handler();
        } catch (error) {
            throw new SubmissionError({ _error: `Unexpected error: ${error.message}` });
        }
    });
};

export const reliablyHandleAsyncFormSubmit = (handler) => {
    return handler().catch(error => {
        const errorMessage = (!isUndefinedNullOrEmpty(error.message)) ? error.message : error;
        throw new SubmissionError({ _error: errorMessage });
    });
};


// WEBPACK FOOTER //
// ./src/components/common/formUtils.js